import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_INSTITUTION_ID,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_ID,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_FAILURE,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_SUCCESS,

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE_SUCCESS,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE_FAILURE,

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE_SUCCESS,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE_FAILURE,

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE_SUCCESS,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE_FAILURE,

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE_SUCCESS,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE_FAILURE,

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC_SUCCESS,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC_FAILURE,

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_CLEAR,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_FILTER,

    InstitutionConfidentialityDeedAction
} from '../actions/institutionConfidentialityDeed';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IInstitutionConfidentialityDeedState {
    formData: Dtos.InstitutionConfidentialityDeed | Dtos.InstitutionConfidentialityDeed[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    validateState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    deleteState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.InstitutionConfidentialityDeed[];
    formLength: number;
}

const initialState: IInstitutionConfidentialityDeedState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    deleteState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: IInstitutionConfidentialityDeedState, _isLoading: boolean): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: IInstitutionConfidentialityDeedState,
    formData: Dtos.InstitutionConfidentialityDeed | Dtos.InstitutionConfidentialityDeed[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: IInstitutionConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: IInstitutionConfidentialityDeedState, formFilter: IFormFilter): IInstitutionConfidentialityDeedState {

    const items: Dtos.InstitutionConfidentialityDeed[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (
            formFilter.search == "" ||
            p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1
        )) : undefined;

    const newState: IInstitutionConfidentialityDeedState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: IInstitutionConfidentialityDeedState, propertiesToClear?: string[]): IInstitutionConfidentialityDeedState {

    if (!propertiesToClear) {
        const newState: IInstitutionConfidentialityDeedState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IInstitutionConfidentialityDeedState, _isSaving: boolean): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IInstitutionConfidentialityDeedState,
    formData: Dtos.InstitutionConfidentialityDeed | Dtos.InstitutionConfidentialityDeed[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IInstitutionConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function validating(state: IInstitutionConfidentialityDeedState, _isValidating: boolean): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: IInstitutionConfidentialityDeedState,
    formData: Dtos.InstitutionConfidentialityDeed | Dtos.InstitutionConfidentialityDeed[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: IInstitutionConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IInstitutionConfidentialityDeedState, _isCreating: boolean): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IInstitutionConfidentialityDeedState,
    formData: Dtos.InstitutionConfidentialityDeed,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IInstitutionConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function deleting(state: IInstitutionConfidentialityDeedState, _isDeleting: boolean): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function deleteSuccess(
    state: IInstitutionConfidentialityDeedState,
): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function deleteFailure(state: IInstitutionConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): IInstitutionConfidentialityDeedState {
    const newState: IInstitutionConfidentialityDeedState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

const InstitutionConfidentialityDeedReducer: Reducer<IInstitutionConfidentialityDeedState> = (state: IInstitutionConfidentialityDeedState = initialState, action: InstitutionConfidentialityDeedAction) => {
    switch (action.type) {
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_INSTITUTION_ID:
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE:
            return saving(state, true);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE:
            return validating(state, true);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE:
            return creating(state, true);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE:
            return deleting(state, true);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE_SUCCESS:
            return deleteSuccess(state);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE_FAILURE:
            return deleteFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_FILTER:
            return filter(state, action.formFilter);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC:
            return loading(state, true);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC_FAILURE:
            return loadFailure(state, action.responseStatus);

    }

    return state;
}

export default InstitutionConfidentialityDeedReducer;